import { createFileRoute, redirect } from '@tanstack/react-router'
import { model } from '@/lib/queries/models'
import { decodeId, encodeId } from '@/lib/short-uuid'
import { LibraryTalentPage } from '@/features/organizations/talent-library/detail'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/talents/$talentId'
)({
  params: {
    parse: (rawParams: { talentId: string }) => {
      try {
        return { talentId: decodeId(rawParams.talentId) }
      } catch {
        return { talentId: rawParams.talentId }
      }
    },
    stringify: (params: { talentId: string }) => ({
      talentId: encodeId(params.talentId),
    }),
  },
  loader: async ({ context, params }) => {
    const talent = await context.queryClient.query(
      model.findOneWithShots(params.talentId)
    )
    if (!talent || talent.workspace_id !== null) {
      throw redirect({
        to: '/org/$orgId/talents',
        params: { orgId: params.orgId },
        replace: true,
      })
    }
  },
  component: LibraryTalentRouteComponent,
})

function LibraryTalentRouteComponent() {
  const { orgId, talentId } = Route.useParams()
  return <LibraryTalentPage orgId={orgId} talentId={talentId} />
}
